module.exports = __webpack_public_path__ + "img/red.285a3574.png";